// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.wrapper[data-v-133585a5] {\r\n  margin-left: 35px;\r\n  margin-bottom: 10px;\r\n  border: 1px solid #bbb;\r\n  padding-left: 10px;\r\n  /* width: 400px; */\r\n  padding: 10px;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\n}\n.uploadTip[data-v-133585a5] {\r\n  font-size: 12px;\r\n  color: #707174;\r\n  margin: 7px 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
